export default "__VITE_ASSET__sZm82poj__"